module.exports = __webpack_public_path__ + "8d3a92953c42857986d19c3b36f5d1dd.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/ork-420.webp
// module id = 484
// module chunks = 0